// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pPAv","colBig":"styles_colBig__MYYXu","colSmall":"styles_colSmall__14VIp"};